import Achievement from "../components/Achievement";

const AchievementInterface = () => {
  return (
    <>
      <Achievement />
    </>
  );
};
export default AchievementInterface;
